/**
 * The CosturAI ids of the dashboard central catalog (`Settings.ServicePermissions`, serviceId 27).
 * The same list as `apps/server/src/common/permissions/costurai-permissions.catalog.json`: the
 * web never imports the server, so the ids are declared on both sides and must match.
 */
export const PERMISSION = {
  INICIO_VIEW: 'costurai_inicio_view',
  CARTEIRA_VIEW: 'costurai_carteira_view',
  CARTEIRA_EDIT: 'costurai_carteira_edit',
  CARTEIRA_IMPORT: 'costurai_carteira_import',
  MAPA_VIEW: 'costurai_mapa_view',
  MAPA_EDIT: 'costurai_mapa_edit',
  FILA_VIEW: 'costurai_fila_view',
  FILA_EDIT: 'costurai_fila_edit',
  APONTAMENTO_VIEW: 'costurai_apontamento_view',
  APONTAMENTO_EDIT: 'costurai_apontamento_edit',
  PRESENCA_VIEW: 'costurai_presenca_view',
  PRESENCA_EDIT: 'costurai_presenca_edit',
  MAQUINAS_VIEW: 'costurai_maquinas_view',
  MAQUINAS_EDIT: 'costurai_maquinas_edit',
  MATERIAIS_VIEW: 'costurai_materiais_view',
  MATERIAIS_EDIT: 'costurai_materiais_edit',
  TEMPOS_VIEW: 'costurai_tempos_view',
  TEMPOS_EDIT: 'costurai_tempos_edit',
  SIMULADOR_VIEW: 'costurai_simulador_view',
  RELATORIOS_VIEW: 'costurai_relatorios_view',
  PORTAL_VIEW: 'costurai_portal_view',
  CADASTROS_VIEW: 'costurai_cadastros_view',
  CADASTROS_EDIT: 'costurai_cadastros_edit',
  CONFIGURACOES_VIEW: 'costurai_configuracoes_view',
  CONFIGURACOES_EDIT: 'costurai_configuracoes_edit',
  SUGESTOES_VIEW: 'costurai_sugestoes_view',
} as const;

export type TPermissionId = (typeof PERMISSION)[keyof typeof PERMISSION];

/** Grants every id (system administrators). Nothing else is a wildcard. */
export const PERMISSION_WILDCARD = '*';
